import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as XLSX from 'xlsx';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { NODATAFOUND, OPERERROR, SAVESUCCESS } from 'src/app/tabms/tab-consts';
import { FieldDictionaryDto } from 'src/app/tabms/models/base/base';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-base-upload-template',
  templateUrl: './base-upload-template.component.html',
  styleUrl: './base-upload-template.component.scss'
})
export class BaseUploadTemplateComponent<T> {
  public progress: number;
  public message: string;
  public excelData: ExcelData<T>[];
  public excelHeaders;
  serviceInstance;
  displayListFields;
  type;
  extraDownloadProperties;
  UploadfromExcel
  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public recievedData,
    private baseService: BaseService,
    private translate: TranslateService
  ) {
    this.serviceInstance = recievedData.service;
    this.type = recievedData.type;
    this.displayListFields = recievedData.displayListFields;
    this.extraDownloadProperties = recievedData.extraDownloadProperties;
    this.UploadfromExcel = this.translate.instant('UploadfromExcel');

  }

  data = [];
  onFileChange(evt: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>evt.target;
    if (target.files.length == 1) {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];
        /* save data */
        this.data = <any>XLSX.utils.sheet_to_json(ws, { header: 1 });

        let keys = this.extractDisplayColumns(this.displayListFields); //this.data.shift();
        let resArr = this.data.map((e) => {
          let obj = {};
          keys.forEach((key, i) => {
            obj[key] = e[i];
          });
          return obj;
        });

        if (this.type == 1) this.excelData = resArr.splice(1, 1);
        else if (this.type == 0) this.excelData = resArr.splice(1, resArr.length - 1);
      };
      reader.readAsBinaryString(target.files[0]);
    }
  }

  uploadfile() {
    if (this.type == 1) this.read();
    else if (this.type == 0) this.createBulkData();
  }

  read() {
    if (this.excelData?.length <= 0) {
      this.baseService.showInfoMessage(NODATAFOUND);
      return;
    }
    this.baseService.uploadedData.next(this.excelData[0]);
  }

  createBulkData() {
    if(this.excelData.length > 0 && this.excelData.every(obj => 'phoneNumber' in obj)){
      this.excelData = this.converMobileToString(this.excelData);
    }
    
    if (this.excelData?.length > 0) {
      this.serviceInstance.createBulk(this.excelData).subscribe(
        (res) => {
          this.baseService.showSuccessMessage(SAVESUCCESS);
          this.baseService.refreshTable.next(true);
        },
        (err) => {
          this.baseService.showErrorMessage(OPERERROR);
        }
      );
    }
  }

  extractDisplayColumns(displayListFields: FieldDictionaryDto[]) {
    let columnsArray = displayListFields.map((x) => x.fieldname);
    columnsArray = columnsArray.concat(this.extraDownloadProperties);
    this.excelHeaders = columnsArray;
    return columnsArray;
  }

  converMobileToString(data) {
    data.map((el) => (el.phoneNumber = el.phoneNumber.toString()));
    return data;
  }
}
interface ExcelData<T> {
  [index: number]: T;
}
